import ComputePipeline from "../../lib/services/compute/computepipeline";

export default class ClearBlobTexPipeline extends ComputePipeline {
  private device: GPUDevice;
  private layout: GPUBindGroupLayout;
  private info_buffer: GPUBuffer | null = null;

  constructor(key: string, shader: GPUShaderModule, device: GPUDevice, threads: number) {
    super(key,threads);
    this.device = device;
    
    this.layout = device.createBindGroupLayout({
      entries: [
        { binding: 0, visibility: GPUShaderStage.COMPUTE, buffer: { type: "read-only-storage" } },
        { binding: 1, visibility: GPUShaderStage.COMPUTE, storageTexture: { access: "write-only", format: "rgba8unorm" } },
      ],
    });

    this.pipeline = device.createComputePipeline({
      layout: device.createPipelineLayout({ bindGroupLayouts: [this.layout] }),
      compute: { module: shader, entryPoint: key },
    });
  }

  build(info_buffer: GPUBuffer): void {
    this.info_buffer = info_buffer;
  }

  rebuild(blob_tex_view: GPUTextureView): void {
    this.bindgroup = this.device.createBindGroup({
      layout: this.layout,
      entries: [
        { binding: 0, resource: { buffer: this.info_buffer! } },
        { binding: 1, resource: blob_tex_view },
      ],
    });
  }
}